import axios from "axios";

export default class AdvanceCruiseService {
  static getAdvanceCruises(yachtId, startDate, endDate) {
    var url = `advanceCruises?yacht_id=${yachtId}&startDate=${startDate}&endDate=${endDate}`;
    return axios.get(url);
  }

  static getAdvanceCruisesReport(yachtId, startDate, endDate) {
    var url = `advanceCruises/report?yacht_id=${yachtId}&startDate=${startDate}&endDate=${endDate}`;
    return axios.get(url,{
      responseType: 'blob',
    });
  }
}
